import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login/login'
import home from '@/components/home/home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      component: home,
      children: [
        {
          path: 'main',  //主页
          component: function (resolve) {
            require(['@/components/main/main'], resolve);
          }
        },
        {
          path: 'editPword',  //修改密码
          component: function (resolve) {
            require(['@/components/personal/editPword'], resolve);
          }
        },
        {
          path: 'personMsg',  //个人信息
          component: function (resolve) {
            require(['@/components/personal/personMsg'], resolve);
          }
        },
        {
          path: 'system/log', //日志管理
          component: function (resolve) {
            require(['@/components/system/log/log'], resolve);
          }
        },
        {
          path: 'system/menu',  //菜单管理
          component: function (resolve) {
            require(['@/components/system/menu/menu'], resolve);
          }
        },
        {
          path: 'system/power', // 权限管理
          component: function (resolve) {
            require(['@/components/system/power/power'], resolve);
          }
        },
        {
          path: 'system/role',  // 角色管理
          component: function (resolve) {
            require(['@/components/system/role/role'], resolve);
          }
        },
        {
          path: 'system/user',  // 用户管理
          component: function (resolve) {
            require(['@/components/system/user/user'], resolve);
          }
        },
        {
          path: 'system/words', // 数据字典
          component: function (resolve) {
            require(['@/components/system/words/words'], resolve);
          }
        },
        // 机构管理
        {
          path: 'org/org', // 机构管理
          component: function (resolve) {
            require(['@/components/organization/organization'], resolve);
          }
        },
        {
          path: 'org/org', // 机构管理
          component: function (resolve) {
            require(['@/components/organization/organization'], resolve);
          }
        },
        // APP管理
        {
          path: 'setting/appUsers', // APP用户管理
          component: function (resolve) {
            require(['@/components/setting/appUsers/appUsers'], resolve);
          }
        },
        {
          path: 'setting/coupon', // 优惠劵
          component: function (resolve) {
            require(['@/components/setting/coupon/coupon'], resolve);
          }
        },
        {
          path: 'setting/customerService', // 客服管理
          component: function (resolve) {
            require(['@/components/setting/customerService/customerService'], resolve);
          }
        },
        {
          path: 'setting/information', // 资讯管理
          component: function (resolve) {
            require(['@/components/setting/information/information'], resolve);
          }
        },
        {
          path: 'setting/informationType', // 资讯类型管理
          component: function (resolve) {
            require(['@/components/setting/informationType/informationType'], resolve);
          }
        },
        {
          path: 'setting/message', // 消息管理
          component: function (resolve) {
            require(['@/components/setting/message/message'], resolve);
          }
        },
        {
          path: 'setting/opinion', // 意见列表
          component: function (resolve) {
            require(['@/components/setting/opinion/opinion'], resolve);
          }
        },
        {
          path: 'setting/rule', // 规则管理
          component: function (resolve) {
            require(['@/components/setting/rule/rule'], resolve);
          }
        },
        {
          path: 'setting/slide', // 幻灯片
          component: function (resolve) {
            require(['@/components/setting/slide/slide'], resolve);
          }
        },

        // 商品管理
        {
          path: 'goods/goodsShelves', // 货架管理
          component: function (resolve) {
            require(['@/components/goods/goodsShelves/goodsShelves'], resolve);
          }
        },
        {
          path: 'goods/goodsType', // 商品分类
          component: function (resolve) {
            require(['@/components/goods/goodsType/goodsType'], resolve);
          }
        },
        {
          path: 'goods/goodsList', // 商品列表
          component: function (resolve) {
            require(['@/components/goods/goodsList/goodsList'], resolve);
          }
        },

        // 订单管理
        {
          path: 'order/orderList', // 零售订单
          component: function (resolve) {
            require(['@/components/order/orderList/orderList'], resolve);
          }
        },

        // 资金管理

        {
          path: 'capital/withdrawals', // 申请提现
          component: function (resolve) {
            require(['@/components/capital/withdrawals/withdrawals'], resolve);
          }
        },

        // 统计报表
        {
          path: 'chart/APPUserStatistics', // APP用户统计
          component: function (resolve) {
            require(['@/components/chart/APPUserStatistics/APPUserStatistics'], resolve);
          }
        },
        {
              path: 'org/cashOut', // 提现管理
              component: function (resolve) {
                require(['@/components/org/userExtract/userExtract'], resolve);
              }
            },
            {
              path: 'org/slider', // 轮播图
              component: function (resolve) {
                require(['@/components/org/slider/slider'], resolve);
              }
            },
            {
              path: 'org/lightApp', // 轻应用
              component: function (resolve) {
                require(['@/components/org/lightApp/lightApp'], resolve);
              }
            },
            //##########
      ],
    },
    {
      path: '/',
      component: login
    },
    {
      path: '/login',
      component: login
    },
    {
      path: '/test/editor',
      component: function (resolve) {
        require(['@/components/test/Editor.vue'], resolve);
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js